export const EVENTS = [
  'error',
  'pause',
  'play',
  'playing',
  'progress',
  'rateChange',
  'seeked',
  'seeking',
  'timeUpdate',
  'volumeChange',
  'waiting'
  // 'canPlay',
  // 'abort',
  // 'canPlayThrough',
  // 'durationChange',
  // 'emptied',
  // 'encrypted',
  // 'ended',
  // 'loadedData',
  // 'loadedMetadata',
  // 'loadStart',
  // 'stalled',
  // 'suspend',
]

export const TRACKEVENTS = [
  'change',
  'addTrack',
  'removeTrack'
]

export const METHODS = [
  'addTextTrack',
  'canPlayType',
  'load',
  'play',
  'pause'
]

export const PROPERTIES = [
  'currentTime',
  'defaultPlaybackRate',
  'duration',
  'ended',
  'error',
  'paused',
  'playbackRate',
  'seeking',
  'src',
  'volume'
  // 'audioTracks',
  // 'autoPlay',
  // 'buffered',
  // 'controller',
  // 'controls',
  // 'currentSrc',
  // 'defaultMuted',
  // 'loop',
  // 'mediaGroup',
  // 'muted',
  // 'networkState',
  // 'played',
  // 'preload',
  // 'readyState',
  // 'seekable',
  // 'startDate',
  // 'textTracks',
  // 'videoTracks',
]
